import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <React.Fragment>
      <section className="section" id="features">
        <Container>
          <Row className="vertical-content">
            <Col lg={5}>
              <div className="features-box">
                <h3>
                  Since its founding in 2021, Quran411.org has been committed 
                  to making the Quran available to everyone in a way that 
                  is clear, authentic, and easy to engage with. 
                  Our mission is to remove barriers to access and empower individuals and communities.
                </h3>
                <p className="text-muted web-desc">
                  Qurʾān, the sacred scripture of Islam. 
                  According to conventional Islamic belief, the Qurʾān was revealed 
                  by the angel Gabriel to the Prophet Muhammad in the West Arabian towns Mecca and Medina 
                  beginning in 610 and ending with Muhammad’s death in 632 CE. The word qurʾān, which occurs 
                  already within the Islamic scripture itself (e.g., 9:111 and 75:17–18), 
                  is derived from the verb qaraʾa—“to read,” 
                  “to recite”—but there is probably also some connection with 
                  the Syriac qeryānā, “reading,” used for the recitation 
                  of scriptural readings during church services. The Qurʾānic corpus, 
                  composed in an early form of Classical Arabic, 
                  is traditionally believed to be a literal transcript of Allmighty God’s 
                  speech and to constitute the earthly reproduction of an uncreated 
                  and eternal heavenly original, according to the general view referred 
                  to in the Qurʾān itself as “the well-preserved tablet” (al-lawḥ al-mahfūẓ; Qurʾān 85:22).

                </p>
                <ul className="text-muted list-unstyled mt-4 features-item-list">
                  <li className="">Quran411.org is originally inspired by Quran411.com.</li>
                  <li className="">Quran411.com is designed by Mr Deen Khederoo and we would like to give him 
                  the creadit he desearve.</li>
                  <li className="">
                    The sole reason of existance of Quran411.org is, Quran411.com is down very often.
                  </li>
                  <li className="">For any error and mistak found please contact us so we can correct the error</li>
                </ul>

                <Link
                  to="https://www.quran411.org/contact-us"
                  className="btn btn-primary mt-4 waves-effect waves-light" >
                  Contact Us <i className="mdi mdi-arrow-right"></i>
                </Link>

                {/* <Link
                  to="https://drive.google.com/drive/folders/1RSU2KGU9MwHPHHrnzuTtllxkhU0Fv31a?usp=sharing"
                  className="btn btn-primary mt-4 waves-effect waves-light" >
                  Android App Download<i className="mdi mdi-arrow-right"></i>
                </Link>

                <Link
                  to="https://drive.google.com/drive/folders/1LSK38Fbs-8Bqdy3e76pxYaWBSg8xw28F?usp=share_link"
                  className="btn btn-primary mt-4 waves-effect waves-light" >
                  iOS App Download<i className="mdi mdi-arrow-right"></i>
                </Link> */}

              </div>
            </Col>
            <Col lg={7}>
              <div className="features-img features-right text-end">
                <img
                  src="assets/images/quran411.png"
                  alt="macbook"
                  className="img-fluid"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default AboutUs;
